import { createApp } from "vue";


import App from './App.vue';
import router from './router'; // 第一步


 
 import domain from '../public/domain';

 
 
 global.domain = domain;

const app = createApp(App);
app.use(router);  

app.mount('#app');

